export default {
  RISK_QUESTIONNAIRE_HEADER:
    "What would you do if your portfolio's value dropped by 20% in the first 3 months?",
  RISK_QUESTIONNAIRE_SUBHEADING:
    "There's no correct answer. This helps us determine your risk tolerance.",
  RADIO_ITEMS: [
    {
      label: "I'd sell at a loss",
      value: "I'd sell at a loss",
    },
    {
      label: "I'd hold my assets",
      value: "I'd hold my assets",
    },
    {
      label: "I'd buy more",
      value: "I'd buy more",
    },
  ],
  RISK_QUESTIONNAIRE_BUTTON_HEADING: "Next",
};
